requestAnimationFrame(() => {
  themeBase.onWindowLoadTrigger(() => {
    if (!customElements.get('mega-menu-mobile-tree')) {
      class megaMenuMobileTree extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.replace();
        }

        replace() {
          const itemWrapper = document.querySelector(`[data-mobile-item-link-handle="${this.dataset.linkHandle}"]`);

          if (!itemWrapper) return;

          const menu = itemWrapper.querySelector('.menu-drawer__menu');
          const menuDefaultContent = menu.innerHTML;
          const menuDefaultClasslist = itemWrapper.getAttribute('class');

          itemWrapper.classList.add('menu-drawer__first-level--has-links');
          menu.innerHTML = this.querySelector('template').content.firstElementChild.cloneNode(true).innerHTML;

          this.returnToDefault = () => {
            itemWrapper.setAttribute('class', menuDefaultClasslist);
            menu.innerHTML = menuDefaultContent;
          };
        }

        disconnectedCallback() {
          if (this.returnToDefault) this.returnToDefault();
        }
      }

      customElements.define('mega-menu-mobile-tree', megaMenuMobileTree);
    }
  });
});